import Swiper, { FreeMode, Scrollbar } from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class SizeGuidePdpModalTable extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      container: '.js-sizeGuideModalTableContainer',
      scrollBar: '.js-sizeGuideModalTableScrollbar',
    };

    this.dom = {
      $component: component,
      $container: this.$get(this.refs.container),
      $scrollBar: this.$get(this.refs.scrollBar),
    };

    this.state = {
      breakpoint: '(min-width: 1024px)',
      swiper: null,
    };

    this.mount();
  }

  mount() {
    super.mount();

    this.checkTableSlider();
    window.addEventListener('resize', this.checkTableSlider.bind(this));
  }

  isDesktop() {
    const { state: { breakpoint } } = this;
    return window.matchMedia(breakpoint).matches;
  }

  checkTableSlider() {
    if (!this.isDesktop()) {
      this.initTableSlider();
    } else {
      this.destroyTableSlider();
    }
  }

  initTableSlider() {
    const { dom, state } = this;
    if (state.swiper) return;

    state.swiper = new Swiper(dom.$container, {
      modules: [FreeMode, Scrollbar],
      direction: 'horizontal',
      slidesPerView: 'auto',
      freeMode: {
        enabled: true,
      },
      scrollbar: {
        el: dom.$scrollBar,
        draggable: true,
        dragClass: 'SizeGuidePdpModalTable__scroll-bar-drag',
        snapOnRelease: false,
      },
    });
  }

  destroyTableSlider() {
    const { state } = this;
    if (!state.swiper) return;

    state.swiper.destroy();
    state.swiper = null;
  }
}
